import { Injectable } from '@angular/core';
import { Model } from '../shared/model';

@Injectable()
export class Location extends Model {

  // properties
  id                  : number
  name                : string
  org_id              : number
  address1            : string
  address2            : string
  address3            : string
  calculated_offset   : number
  city                : string
  company             : string
  coordinates_lat     : string
  coordinates_lng     : string
  country             : string
  phone               : string
  prov                : string
  tz                  : string
  zip                 : string

  constructor(obj: Location) {
    super(obj);
  }
}
